let request = require('superagent-use')(require('superagent'));
import _ from 'lodash';

export default class PropertyTypeResource {
    getPropertyTypes(token, subscriberId) {
        return new Promise((resolve, reject) => {
            request
                .get(`api/primes/subscribers/${subscriberId}/propertytypes`)
                .set('api-key', 'Bearer ' + token)
                .end((error, res) => {
                    error ? reject(error) : resolve(res.body);
                });
        });
    }
}



// WEBPACK FOOTER //
// ./src/files/propertytype-resource.js